 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"auth":"auth","components":"components","lesson":"lesson","quiz":"quiz","tasting":"tasting","user":"user"}[chunkId]||chunkId) + "." + {"auth":"009102b6","chunk-2d0a4f5a":"a1db8c77","chunk-2d0ab4d9":"3292f957","chunk-2d0ae8de":"d0727613","chunk-2d0b1d8a":"e1a130f9","chunk-2d0b1e82":"3c4b3bb0","chunk-2d0b2b1a":"48e620e9","chunk-2d0b8a48":"77817f86","chunk-2d0b8b00":"77b00c1f","chunk-2d0b8dd4":"32840a46","chunk-2d0c0703":"53927d0f","chunk-2d0c0c73":"844b6fc0","chunk-2d0c18bb":"f031b153","chunk-2d0c1cbe":"7780bc6b","chunk-2d0c45fa":"97922df3","chunk-2d0c9b36":"1d6ce5f7","chunk-2d0cba78":"464ce672","chunk-2d0d0235":"d28c7858","chunk-2d0d7e43":"f039d085","chunk-2d0daad8":"28a0c728","chunk-2d0dd016":"70fca448","chunk-2d0dd0aa":"e4d6ddab","chunk-2d0dee93":"c01c7bd1","chunk-2d0e1760":"57ee4256","chunk-2d0e1fa0":"628690b8","chunk-2d0e2380":"b29bfbce","chunk-2d0e906d":"b789e48a","chunk-2d0e925f":"2ed659e8","chunk-2d0e982e":"d5ac52ef","chunk-2d20738a":"a2a6efe8","chunk-2d207b36":"ece1cb4d","chunk-2d207d82":"7136f684","chunk-2d208e0b":"1da64ad8","chunk-2d20f724":"6e28718e","chunk-2d216023":"5afa517c","chunk-2d217329":"c050a44b","chunk-2d21b49e":"13401072","chunk-2d21b4ba":"3eddd66e","chunk-2d21b8d8":"d8cfdcc6","chunk-2d225864":"2db971ba","chunk-2d22d204":"7c763b42","chunk-2d22e0d7":"8f703218","chunk-2d230448":"5a43b6ec","chunk-2d2307da":"304568a3","chunk-2d2308ce":"ea29b18e","chunk-2d237562":"3c8b09a8","chunk-2d237d3e":"36c0c785","chunk-74acec85":"74197919","components":"663faa70","lesson":"5fc7c89a","quiz":"6930b104","tasting":"71c7b87f","user":"f41f6b17"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"auth":1,"components":1,"lesson":1,"quiz":1,"tasting":1,"user":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"auth":"auth","components":"components","lesson":"lesson","quiz":"quiz","tasting":"tasting","user":"user"}[chunkId]||chunkId) + "." + {"auth":"7b77002a","chunk-2d0a4f5a":"31d6cfe0","chunk-2d0ab4d9":"31d6cfe0","chunk-2d0ae8de":"31d6cfe0","chunk-2d0b1d8a":"31d6cfe0","chunk-2d0b1e82":"31d6cfe0","chunk-2d0b2b1a":"31d6cfe0","chunk-2d0b8a48":"31d6cfe0","chunk-2d0b8b00":"31d6cfe0","chunk-2d0b8dd4":"31d6cfe0","chunk-2d0c0703":"31d6cfe0","chunk-2d0c0c73":"31d6cfe0","chunk-2d0c18bb":"31d6cfe0","chunk-2d0c1cbe":"31d6cfe0","chunk-2d0c45fa":"31d6cfe0","chunk-2d0c9b36":"31d6cfe0","chunk-2d0cba78":"31d6cfe0","chunk-2d0d0235":"31d6cfe0","chunk-2d0d7e43":"31d6cfe0","chunk-2d0daad8":"31d6cfe0","chunk-2d0dd016":"31d6cfe0","chunk-2d0dd0aa":"31d6cfe0","chunk-2d0dee93":"31d6cfe0","chunk-2d0e1760":"31d6cfe0","chunk-2d0e1fa0":"31d6cfe0","chunk-2d0e2380":"31d6cfe0","chunk-2d0e906d":"31d6cfe0","chunk-2d0e925f":"31d6cfe0","chunk-2d0e982e":"31d6cfe0","chunk-2d20738a":"31d6cfe0","chunk-2d207b36":"31d6cfe0","chunk-2d207d82":"31d6cfe0","chunk-2d208e0b":"31d6cfe0","chunk-2d20f724":"31d6cfe0","chunk-2d216023":"31d6cfe0","chunk-2d217329":"31d6cfe0","chunk-2d21b49e":"31d6cfe0","chunk-2d21b4ba":"31d6cfe0","chunk-2d21b8d8":"31d6cfe0","chunk-2d225864":"31d6cfe0","chunk-2d22d204":"31d6cfe0","chunk-2d22e0d7":"31d6cfe0","chunk-2d230448":"31d6cfe0","chunk-2d2307da":"31d6cfe0","chunk-2d2308ce":"31d6cfe0","chunk-2d237562":"31d6cfe0","chunk-2d237d3e":"31d6cfe0","chunk-74acec85":"31d6cfe0","components":"6f24fddb","lesson":"853e35db","quiz":"fa06f73a","tasting":"492ed1d8","user":"a2c73f93"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
